import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { useAuthStore } from '@/features/auth/store/authStore'
import { LoadingSpinner } from '@/shared/components/feedback/LoadingSpinner'
import { ROUTES } from '@/shared/constants/routes'
import type { UserRole } from '@/shared/types/app.types'

interface AuthGuardProps {
  requiredRole?: UserRole
}

export function AuthGuard({ requiredRole = 'member' }: AuthGuardProps) {
  const { isAuthenticated, isLoading, isAdmin } = useAuthStore(
    useShallow((state) => ({
      isAuthenticated: state.isAuthenticated,
      isLoading: state.isLoading,
      isAdmin: state.isAdmin,
    }))
  )
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  // Not logged in — redirect to auth
  if (!isAuthenticated) {
    return <Navigate to={ROUTES.AUTH} state={{ from: location }} replace />
  }

  // Role check
  if (requiredRole === 'admin' && !isAdmin) {
    return <Navigate to={ROUTES.DASHBOARD} replace />
  }

  return <Outlet />
}
